import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import wordCupLogo from './Images/WC-logo.png';
import googleIcon from './Images/GoogleIcon.svg';
import appleIcon from './Images/Apple_logo_black.svg'

import { InAppBrowser } from '@ionic-native/in-app-browser';

// this function is globally accessible and acts as an event listener for ios
window.handleOpenURL = function (url) {
  setTimeout(function () {
    if (window.cordova && window.cordova.platformId === 'ios') {
      handleOpenURLIOS(url);
    }
  }, 0);
};

function handleOpenURLIOS(url) {
  setTimeout(function () {
    // Handle the URL
    window.SafariViewController.hide();

    //url: potgame://localhost/index.html#/?code=103042557954214157734

    if (url.startsWith('potgame://localhost')) {
      // Extract the code from the URL
      var codeMatch = /code=([^&]+)/.exec(url);
      if (codeMatch && codeMatch.length > 1) {
        const code = codeMatch[1];

        // Dispatch custom event with the code
        const event = new CustomEvent('OAuthCodeReceived', { detail: code });
        window.dispatchEvent(event);
      }
    }
  }, 0);
}

class LoginJustGoogle extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;

    this.state = {
      userEmail: '',
      userPassword: '',
    };
  }

  componentDidMount() {
    window.addEventListener('OAuthCodeReceived', this.handleOAuthCode);
  }

  componentWillUnmount() {
    window.removeEventListener('OAuthCodeReceived', this.handleOAuthCode);
  }

  handleOAuthCode = (event) => {
    const code = event.detail;
    this.props.cookies.set('code', code);
    localStorage.setItem('code', code);
    this.props.navigate('/');
  };

  handleLogin = (apple) => {
    if (window.cordova && window.viewType === 'phone') {
      switch (window.cordova.platformId) {
        case 'ios':
          this.handleLoginIOS(apple);
          break;
        case 'android':
          this.handleLoginAndroid(apple);
          break;
        default:
          // handle other platforms or default behavior
          break;
      }
    } else {
      console.log('Device plugin not available. Running in browser');
      // Handle browser or fallback behavior
      window.location.href = `${
        process.env.NODE_ENV === 'development' ? 'http://localhost:9000' : ''
      }/api/OAuth${apple ? '/apple' : ''}/login`;
    }
  };

  handleLoginIOS = (apple) => {
    window.SafariViewController.isAvailable((available) => {
      if (available) {
        window.SafariViewController.show(
          {
            //change to backendIOS if this does not work
            url: `${process.env.REACT_APP_MOBILE_BACKEND_URL}/api/OAuth${apple ? '/apple' : ''}/login?viewType=${window.cordova.platformId}`,
          },
          function (result) {
            console.log(
              'goes inside window.SafariViewController.isAvailable success handler'
            );
          },
          function (error) {
            console.log(
              `window.SafariViewController.isAvailable error: ${error}`
            );
            console.log(error);
          }
        );
      }
    });
  };

  handleLoginAndroid = (apple) => {
    let inAppBrowserRef = InAppBrowser.create(
      `${process.env.REACT_APP_MOBILE_BACKEND_URL}/api/OAuth${apple ? '/apple' : ''}/login?viewType=${window.cordova.platformId}`,
      '_blank',
      'location=no, toolbar=no, sharedCookiesEnabled=yes'
    );

    /* Add event listener to close InAppBrowser*/
    inAppBrowserRef.on('loadstart').subscribe((event) => {
      /* Close InAppBrowser if loading the predefined close URL */
      if (event.url.startsWith('https://localhost')) {
        const [url, code] = event.url.split('?code=');

        const path = url.split('index.html#')[1];

        inAppBrowserRef.close();

        this.props.cookies.set('code', code);
        localStorage.setItem('variableName', code);

        this.props.navigate(path);
      }
    });
  };

  // Error Handler
  responseGoogleError = (response) => {
    console.log('Error response: ' + response);
  };

  // Logout Session and Update State
  handleLogOut = () => {
    this.props.cookies.remove('code');
    this.forceUpdate();
  };

  render() {
    return (
      <div className="Home">
        <img className="wordCupLogoImg" src={wordCupLogo} alt="word Cup Logo" />

        <button
          className="googleLoginButton"
          style={{ marginTop: '400px' }}
          onClick={() => {this.handleLogin(false);}}
          type="button">
          <img
            className="googleButtonIcon"
            src={googleIcon}
            alt="Google Icon"></img>
          <p style={{ marginLeft: '10px' }}>Вход с Google</p>
        </button>

        <button
          className="googleLoginButton"
          style={{ marginTop: '5px' }}
          onClick={() => {this.handleLogin(true);}}
          type="button">
          <img
            className="googleButtonIcon"
            src={appleIcon}
            alt="Google Icon"></img>
          <p style={{ marginLeft: '10px' }}>Вход с Apple</p>
        </button>
      </div>
    );
  }
}

export default withCookies(LoginJustGoogle);
